import { Input } from "@/components/ui/input";


export default function XeroLegacyOfficeCell({
  draft,
  tenantName,
  isPending,
  onDraftChange,
}: {
  draft: string;
  tenantName: string;
  isPending: boolean;
  onDraftChange: (next: string) => void;
}) {
  return (
    <Input
      value={draft}
      onChange={(e) => onDraftChange(e.target.value)}
      disabled={isPending}
      maxLength={200}
      className="h-8"
      placeholder="Add a legacy office"
      aria-label={`Legacy office for ${tenantName}`}
    />
  );
}
